<template>
  <v-dialog
    v-model="isOpenTaskCSDK"
    max-width="530"
    persistent
    :retain-focus="false"
  >
    <v-card class="quick-view">
      <v-card-title
        class="font-weight-bold white--text pa-2"
        style="background: #4d4cac; font-size: 16px; font-weight: 700"
      >
        Công việc {{formDetailTask.type === 1 ? 'chăm sóc định kỳ' : 'gia hạn'}}
      </v-card-title>
      <v-card-text class="my-5 pa-0 d-flex card-text-body">
        <div class="px-4 w-full">
          <div class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold"
                >Loại công việc <span style="color: #c62828">*</span></span
              >
            </div>
            <div style="width: 80%" class="d-flex">
              <v-autocomplete
                v-model="formDetailTask.type"
                :items="listType"
                item-text="text"
                item-value="id"
                label
                dense
                class="custome-select-border-view"
                :class="{ required: required && !formDetailTask.type }"
                :disabled="typeForm === 'edit'"
              />
              <div v-if="typeForm === 'edit'" @click="formDetailTask.status !== 2 ? changeStatus() : ''" class="d-flex ml-2 mb-2" style="cursor: pointer;">
                <img v-if="formDetailTask.status === 2" src="./assets/img/successtask.svg" alt="" style="height: 28px; width: 28px; margin-top: 4px">
                <img v-else src="./assets/img/todotask.svg" alt="" style="height: 28px; width: 28px; margin-top: 4px">
              </div>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold">Tiêu đề <span style="color: #c62828">*</span></span>
            </div>
            <div style="width: 80%">
              <v-text-field
                class="custom-input-task"
                v-model="titleTask"
                outlined
                disabled
                :class="{ required: required && !titleTask }"
              />
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold"
                >Nội dung <span style="color: #c62828">*</span></span
              >
            </div>
            <div style="width: 80%">
              <v-textarea
                v-model="formDetailTask.content"
                label
                :counter="250"
                :maxlength="250"
                class="custom-input-task textarea-type"
                :class="{ required: required && !formDetailTask.content }"
              />
            </div>
          </div>
          <div class="d-flex justify-space-between my-2">
            <div class="label-input">
              <span class="font-weight-bold"
                >Lịch hẹn <span style="color: #c62828">*</span></span
              >
            </div>
            <div style="width: 80%" class="d-flex justify-space-between">
              <div style="width: 65%">
                <v-menu
                  ref="datePicker"
                  v-model="datePicker"
                  :close-on-content-click="false"
                  :return-value.sync="formDetailTask.appointment_schedule"
                  offset-y
                  bottom
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-on="on"
                      v-bind="attrs"
                      class="d-flex data-picker-task justify-space-between"
                    >
                      <div>
                        {{
                          formatDataTime(formDetailTask.appointment_schedule)
                        }}
                      </div>
                      <div class="d-flex">
                        <img src="./assets/calender.svg" alt="" srcset="" />
                      </div>
                    </div>
                  </template>
                  <div>
                    <v-date-picker
                      v-model="formDetailTask.appointment_schedule"
                      color="secondary"
                      class="custom-date-picker"
                      scrollable
                      :disabled="formDetailTask.status === 2"
                      :min="today"
                      @change="
                        $refs.datePicker.save(
                          formDetailTask.appointment_schedule
                        ),
                          (datePicker = false)
                      "
                    >
                    </v-date-picker>
                  </div>
                </v-menu>
              </div>
              <div style="width: 30%">
                <input type="time" v-model="selectedTime" :class="{ required: required && !selectedTime }"  :disabled="formDetailTask.status === 2"/>
              </div>
            </div>
          </div>
          <div class="d-flex justify-space-between my-2">
            <div class="label-input">
              <span class="font-weight-bold">Nhắc hẹn</span>
            </div>
            <div style="width: 80%" class="d-flex justify-space-between">
              <div style="width: 55%">
                <v-select
                  v-model="formDetailTask.reminder_type"
                  :items="REMIDER_TYPE"
                  item-text="label"
                  item-value="id"
                  label
                  class="custome-select-border-view"
                  :disabled="formDetailTask.status === 2"
                >
                  <template v-slot:selection="{ props, item }">
                    <div v-bind="props" class="d-flex align-center">
                      <img
                        src="./assets/lockring.svg"
                        alt=""
                        srcset=""
                        class="mx-2"
                      />
                      <span style="font-size: 14px; font-weight: 400">{{
                        item.label
                      }}</span>
                    </div>
                  </template>
                </v-select>
              </div>
              <div style="width: 40%" class="d-flex custom-switch">
                <v-switch
                  v-model="formDetailTask.is_notice_popup"
                  class="mt-0 ms-2"
                  density="compact"
                  label="Thông báo popup"
                  color="#4d4cac"
                  hide-details
                  :disabled="formDetailTask.status === 2"
                ></v-switch>
              </div>
            </div>
          </div>

          <div class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold">Học viên</span>
            </div>
            <div style="width: 80%">
              <v-text-field
                class="custom-input-task"
                v-model="formDetailTask.userStudent.fullName"
                outlined
                disabled
              />
            </div>
          </div>
          <div v-if="formDetailTask.curriculum && formDetailTask.curriculum.title" class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold">Chương trình</span>
            </div>
            <div style="width: 80%">
              <v-text-field
                class="custom-input-task"
                v-model="formDetailTask.curriculum.title"
                outlined
                disabled
              />
            </div>
          </div>
          <div v-else class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold">Khoá học <span style="color: #c62828">*</span></span>
            </div>
            <div style="width: 80%">
              <v-autocomplete
                v-model="formDetailTask.course_id"
                :items="listCourse"
                item-text="name"
                item-value="id"
                label
                dense
                class="custome-select-border-view"
                :class="{ required: required && !formDetailTask.course_id }"
                :disabled="typeForm === 'edit'"
              />
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="label-input">
              <span class="font-weight-bold">Người thực hiện <span style="color: #c62828">*</span></span>
            </div>
            <div style="width: 80%">
              <v-autocomplete
                v-model="formDetailTask.user_id"
                :items="listGVCNV2"
                item-text="name"
                item-value="id"
                label
                class="custome-select-border-view"
                :disabled="formDetailTask.status === 2"
                :class="{ required: required && !formDetailTask.user_id }"
              />
            </div>
          </div>
          <div class="w-full py-2" v-if="typeForm !== 'create'">
            <CommentTask
              :isOpenTaskCSDK="isOpenTaskCSDK"
              :listComment="listComment"
              @sendComment="sendComment($event)"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          v-if="typeForm === 'create'"
          @click="createData()"
          class="btn-update"
          >Tạo</v-btn
        >
        <v-btn v-else @click="createData()" class="btn-update" :style="{backgroundColor:!editFlag ? 'rgba(92, 91, 220, 0.6) !important': ''}" :disabled="!editFlag">
          Cập nhật
        </v-btn>
        <v-btn @click="closeModal()" class="btn-close"> Huỷ </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import * as moment from 'moment';
import { mapActions, mapState, mapGetters } from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';
import { TASK_STATUS } from '@/modules/blended/const';
import CommentTask from './CommentTask.vue';

export default {
  name: 'PopupCreateAndEditTask',
  components: {
    CommentTask,
  },
  props: {},
  data() {
    return {
      TASK_STATUS,
      typeForm: 'create', // "create" or "edit
      lessonHomework: {},
      isOpenTaskCSDK: false,
      listType: [
        { id: 1, text: 'Chăm sóc định kỳ' },
        { id: 2, text: 'Gia hạn' },
      ],
      formDetailTask: {
        type: 1,
        content: '',
        appointment_schedule: moment(new Date()).format('YYYY-MM-DD'),
        reminder_type: 1,
        reminder_time: 0,
        is_notice_popup: true,
        lms_core_user_id: null,
        curriculum_id: null,
        user_id: null,
        userStudent: { fullName: '' },
        curriculum: { title: '' },
        course_id: null,
      },
      datePicker: false,
      selectedTime: '18:00',
      REMIDER_TYPE: [
        { id: 1, value: '0', label: 'Đúng giờ đặt hẹn' },
        { id: 2, value: '10', label: 'Trước 10 phút' },
        { id: 3, value: '20', label: 'Trước 20 phút' },
        { id: 4, value: '30', label: 'Trước 30 phút' },
        { id: 5, value: '60', label: 'Trước 1 tiếng' },
      ],
      required: false,
      titleTask: '',
      editFlag: false,
      listComment: [],
      handlerClick: 0,
      listCourse: [],
    };
  },
  watch: {
    'formDetailTask.content': {
      handler(val) {
        if (val) {
          this.required = false;
        }
      },
    },
    'formDetailTask.type': {
      handler(val) {
        if (this.typeForm === 'create') {
          const params = {
            type: val,
            curriculum_id: this.formDetailTask.curriculum_id,
            lms_core_user_id: this.formDetailTask.lms_core_user_id,
          };
          if (this.formDetailTask.course_id && this.formDetailTask.curriculum_id === 0) {
            params.course_id = this.formDetailTask.course_id;
            this.getGenTitleTask(params);
          }
          if (this.formDetailTask.curriculum_id !== 0) this.getGenTitleTask(params);
        }
      },
    },
    'formDetailTask.course_id': {
      handler(val) {
        if (val) {
          this.getGenTitleTask({
            type: this.formDetailTask.type, curriculum_id: this.formDetailTask.curriculum_id, lms_core_user_id: this.formDetailTask.lms_core_user_id, course_id: val,
          });
        }
      },
    },
    formDetailTask: {
      handler(val) {
        if (val && val.status !== 2) {
          this.editFlag = true;
        }
      },
      deep: true,
    },
    selectedTime(val) {
      if (val) {
        this.editFlag = true;
      }
    },
  },
  async created() {
    if (!this.listGVCNV2) {
      await this.getListGVCNV2();
    }
    Bus.$on('openModalTriggerTask', async (detailTask, student) => {
      if (detailTask) {
        this.typeForm = 'edit';
        this.formDetailTask = _.cloneDeep(detailTask);
        console.log('formDetailTask', this.formDetailTask);
        this.formDetailTask.appointment_schedule = this.updateFormat(detailTask.appointment_schedule, 'YYYY-MM-DD');
        this.selectedTime = this.updateFormat(detailTask.appointment_schedule, 'HH:mm');
        this.titleTask = detailTask.title;
        if (detailTask.curriculum_id === 0) await this.getListCourse({ lms_core_user_id: detailTask.lms_core_user_id });
        await this.getListComment();
        this.editFlag = false;
      } else {
        this.typeForm = 'create';
        this.formDetailTask = {
          type: student.type_customer_care === 2 ? 2 : 1,
          content: '',
          appointment_schedule: this.tomorrow,
          reminder_type: 1,
          reminder_time: 0,
          is_notice_popup: true,
          lms_core_user_id: student.lms_core_user_id,
          curriculum_id: student.curriculum_id,
          userStudent: { fullName: student.full_name ? student.full_name : student.fullName },
          curriculum: { title: student.type_curriculum === 'ielts_course' ? null : this.mapProgramIdAndProgram[student.curriculum_id].title },
          user_id: this.listGVCNV2.find((item) => item.id === student.homeroom_teacher_id) ? this.listGVCNV2.find((item) => item.id === student.homeroom_teacher_id).id : null,
        };
        this.selectedTime = '18:00';
        if (student.type_curriculum === 'ielts_course') await this.getListCourse({ lms_core_user_id: student.lms_core_user_id });
        if (student.type_curriculum !== 'ielts_course') this.getGenTitleTask({ type: this.formDetailTask.type, curriculum_id: student.curriculum_id, lms_core_user_id: student.lms_core_user_id });
      }
      this.isOpenTaskCSDK = true;
    });
  },
  computed: {
    ...mapState('student_care', ['listGVCNV2']),
    ...mapState('login', ['user']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    today() {
      return moment(new Date()).format('YYYY-MM-DD');
    },
    tomorrow() {
      return moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
    },
  },
  methods: {
    ...mapActions('student_care', ['getListGVCNV2']),
    closeModal() {
      this.isOpenTaskCSDK = false;
      this.titleTask = '';
      this.required = false;
    },
    formatDataTime(date) {
      const daysOfWeek = [
        'Chủ nhật',
        'Thứ 2',
        'Thứ 3',
        'Thứ 4',
        'Thứ 5',
        'Thứ 6',
        'Thứ 7',
      ];
      const [year, month, day] = date.split('-');
      const formattedDate = `${
        daysOfWeek[new Date(year, month - 1, day).getDay()]
      } ${day}/${month}/${year}`;
      return formattedDate;
    },
    async createData() {
      if (this.formDetailTask.content.trim() === '' || !this.formDetailTask.type || !this.selectedTime || !this.formDetailTask.user_id || !this.formDetailTask.user_id || !this.titleTask) {
        this.required = true;
      } else {
        this.handlerClick += 1;
        if (this.handlerClick > 1) {
          return;
        }
        if (this.typeForm !== 'create' && !this.checkSchoolLevelPermission('create-task-blended_update', 'create-task-blended-secondary_update') && !this.checkAuthorization('create-task-tutor_update') && !this.checkAuthorization('create-task-tutor-secondary_update')) {
          this.$swal({
            type: 'error',
            title: 'Thất bại',
            text: 'Bạn không có quyền thực hiện tính năng này',
          });
          this.handlerClick = 0;
          return;
        }
        // i want to check this.selectedTime have < real time
        const currentTime = moment(new Date()).format('HH:mm');
        if (this.selectedTime < currentTime && this.formDetailTask.appointment_schedule === this.today) {
          this.$swal({
            type: 'error',
            title: 'Thất bại',
            text: 'Thời gian hẹn phải lớn hơn thời gian hiện tại',
          });
          this.handlerClick = 0;
          return;
        }
        const body = {
          type: this.formDetailTask.type,
          content: this.formDetailTask.content,
          appointment_schedule: `${this.formDetailTask.appointment_schedule} ${this.selectedTime}`,
          reminder_type: this.formDetailTask.reminder_type,
          is_notice_popup: this.formDetailTask.is_notice_popup,
          lms_core_user_id: this.formDetailTask.lms_core_user_id,
          curriculum_id: this.formDetailTask.curriculum_id,
          user_id: this.formDetailTask.user_id,
          title: this.titleTask,
          course_id: this.formDetailTask.course_id ? this.formDetailTask.course_id : null,
        };
        const result = this.typeForm === 'create' ? await StudentCareServices.createTask(body) : await StudentCareServices.updateTask(this.formDetailTask.id, body);
        if (result && result.error) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Có lỗi xảy ra, vui lòng thử lại !',
          });
        } else {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: `${this.typeForm === 'create' ? 'Tạo' : 'Cập nhật'} công việc thành công!`,
            position: 'top',
          });
          this.isOpenTaskCSDK = false;
          this.handlerClick = 0;
          Bus.$emit('reloadListTask');
          Bus.$emit('reloadListLite');
        }
      }
    },
    async changeStatus() {
      const result = await StudentCareServices.updateTask(this.formDetailTask.id, { status: 2 });
      if (result && result.errors) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.formDetailTask.status = 2;
        this.$swal({
          type: 'success',
          icon: 'success',
          showConfirmButton: false,
          toast: true,
          timer: 1000,
          title: 'Cập nhật trạng thái thành công!',
          position: 'top',
        });
        Bus.$emit('reloadListTask');
        Bus.$emit('reloadListLite');
      }
    },
    async sendComment(content) {
      const params = {
        content,
        task_id: this.formDetailTask.id,
      };
      const result = await StudentCareServices.createComment(params);
      if (result && result.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.getListComment();
      }
    },
    async getListComment() {
      const res = await StudentCareServices.getListCommentById(this.formDetailTask.id);
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.listComment = res.data;
      }
    },
    async getGenTitleTask(body) {
      const res = await StudentCareServices.getGenTitleTask(body);
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.titleTask = res.data;
      }
    },
    updateFormat(date, format) {
      const result = moment(date).format(format);
      return result;
    },
    async getListCourse(params) {
      const res = await StudentCareServices.getListCourseForTask(params);
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.listCourse = res.data;
      }
    },
  },
  destroyed() {
    this.required = false;
    Bus.$off('openModalTriggerTask');
  },
};
</script>
<style lang="scss" scoped>
input[type="time"] {
  padding: 7px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline-color: #007bff;
  width: 100%;
  /* Add outline color here */
  &.required {
    border: 1px solid #FF5A5F !important;
  }
}

input[type="time"]:focus {
  outline-color: #007bff;
  /* Set the same color for the focus state */
}
.btn-close {
  color: #53545c !important;
  border-radius: 25px;
  font-weight: bold;
  padding: 0 15px !important;
  height: 35px !important;
  background-color: #e0e0e0 !important;
}
.btn-update {
  color: #fff !important;
  border-radius: 25px;
  font-weight: bold;
  padding: 0 15px !important;
  height: 35px !important;
  background-color: rgba(92, 91, 220) !important;
  &.v-btn--disabled {
    color: #fff !important;
  }
}
.label-input {
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}

.card-text-body {
  max-height: 72vh;
  overflow-y: auto;
  font-size: 14px !important;
}

.card-text-body::-webkit-scrollbar {
  width: 5px;
  background-color: #fff;
}

.card-text-body::-webkit-scrollbar-thumb {
  border-radius: 2px;
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
  background-color: #d9d9d9;
}
.custom-date-picker {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
</style>
<style lang="scss">
@import "./assets/index.scss";
</style>
